import { HelpOutline } from "@material-ui/icons";
import { useStepLabels } from "../../context/StepLabelsContext";

export default function StepLabelsHelpToggle({ showMenuText }) {
    const { stepLabelsVisible, toggleStepLabels } = useStepLabels();

    const handleToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleStepLabels();
    };

    return (
        <li
            className="sidebarListItem sidebarHelpToggleItem"
            onClick={showMenuText ? undefined : handleToggle}
            title={
                showMenuText
                    ? undefined
                    : stepLabelsVisible
                      ? "Hide step labels"
                      : "Show step labels"
            }
        >
            <HelpOutline
                className={`sidebarIcon sidebarHelpIcon${
                    stepLabelsVisible ? "" : " sidebarHelpIcon--muted"
                }`}
            />
            {showMenuText && (
                <div className="sidebarHelpToggleRow">
                    <span className="sidebarHelpToggleLabel">Help</span>
                    <button
                        type="button"
                        role="switch"
                        aria-checked={stepLabelsVisible}
                        aria-label="Toggle step labels"
                        className={`step-labels-switch ${
                            stepLabelsVisible ? "is-on" : "is-off"
                        }`}
                        onClick={handleToggle}
                    >
                        <span className="step-labels-switch__track">
                            <span className="step-labels-switch__thumb" />
                        </span>
                    </button>
                </div>
            )}
        </li>
    );
}
